import './../stylesheets/actiontext';
import './../stylesheets/activity_reports';

import * as carouselComponent from './components/carousel';
import * as articleComponent from './components/article';
import * as fileFieldComponent from './components/file_field';
import * as searchComponent from './components/search';
import * as formComponent from './components/form';

// ページ読み込み時の処理
document.addEventListener('turbolinks:load', function() {
  // メインカルーセル
  carouselComponent.syncingCarousel();
  // 記事のアクション
  articleComponent.addPublishedPeriodLabelRequired();
  articleComponent.selectPublishedPeriodType();
  articleComponent.blockOldLink();
    // ファイルフィールドのアクション
  fileFieldComponent.selectFileFieldActions();
  fileFieldComponent.selectFileAfterActions();
  fileFieldComponent.cancelSelectFile();
  fileFieldComponent.destroySelectFile();
  // 詳細検索のアクション
  searchComponent.submitAction();
  searchComponent.ajaxSearchGroupResult();
  // フォームのアクション
  formComponent.temporarilySave();
})
